import React from "react";
import PropTypes from "prop-types";
import { monthlyCommison } from "../../../locales/en";
import { industryViewType, countries } from "../../../utils/data/data";
import styles from "./../../../assets/scss/custom.module.scss";
import ".././reportStyle.scss";
import { MONTH, QUARTER, YEAR } from "../../../utils/constants/appConstants";
import {
  getDataTypes,
  getPeriods,
  getYears_periods
} from "../../../utils/getDropdownOptions";

const ModalSelectFilter = ({
  setCountry,
  setTimePeriods,
  setView,
  country,
  timePeriods,
  view,
  setDataType,
  dataType,
  loading
}) => {
  const handleViewInputChange = (event) => {
    const selectedView = event.target.value;
    setView(selectedView);
    if (selectedView === QUARTER) {
      setTimePeriods("4");
    } else if (selectedView === MONTH) {
      setTimePeriods("12");
    } else if (selectedView === YEAR) {
      setTimePeriods("");
    }
  };

  const handleTimePeriodsInputChange = (event) => {
    setTimePeriods(event.target.value);
  };

  const handleCountryInputChange = (event) => {
    setCountry(event.target.value);
  };
  const handleDataTypeInputChange = (event) => {
    setDataType(event.target.value);
  };

  return (
    <div className="filter align-self-md-center mb-3 mb-md-0 main-filter-bar flex-wrap">
      <div className="row">
        <div className="mb-1 mt-1 col-md-3">
          <label
            htmlFor="Status-sort"
            className={`${styles.selectStatusLabel} d-block align-self-center`}
          >
            {monthlyCommison?.filter.viewType}
          </label>
          <select
            name="view"
            className={styles.selectShowStatus}
            value={view}
            onChange={handleViewInputChange}
            disabled={loading}
          >
            {industryViewType.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-1 mt-1 col-md-3">
          <label
            htmlFor="Customer-Status"
            className={`${styles.selectStatusLabel} d-block align-self-center`}
          >
            {monthlyCommison?.filter.periods}
          </label>
          <select
            name="timePeriods"
            className={styles.selectShowStatus}
            value={timePeriods}
            onChange={handleTimePeriodsInputChange}
            disabled={loading}
          >
            {view === YEAR && (
              <>
                {getYears_periods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.label}
                  </option>
                ))}
              </>
            )}
            {view === MONTH && (
              <>
                {getPeriods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.label}
                  </option>
                ))}
              </>
            )}
            {view === QUARTER && (
              <>
                {getPeriods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.label}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
        <div className="mb-1 mt-1 col-md-3">
          <label
            htmlFor="Customer-Status"
            className={`${styles.selectStatusLabel} d-block align-self-center`}
          >
            {monthlyCommison?.filter.selectCountry}
          </label>
          <select
            name="country"
            className={styles.selectShowStatus}
            value={country}
            onChange={handleCountryInputChange}
            disabled={loading}
          >
            {countries.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.name}
              </option>
            ))}
          </select>
        </div>
        <div className="mb-1 mt-1 col-md-3">
          <label
            htmlFor="Customer-Status"
            className={`${styles.selectStatusLabel} d-block align-self-center`}
          >
            {monthlyCommison?.filter.dataType}
          </label>
          <select
            name="dataTypes"
            className={`${styles.selectShowStatus}`}
            value={dataType}
            onChange={handleDataTypeInputChange}
            disabled={loading}
          >
            {getDataTypes.map((filter) => (
              <option key={filter.id} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

ModalSelectFilter.propTypes = {
  setCountry: PropTypes.func.isRequired,
  setTimePeriods: PropTypes.func.isRequired,
  setView: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  timePeriods: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  dataType: PropTypes.string.isRequired,
  setDataType: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ModalSelectFilter;
